import { CreateQueueModel, ProjectQueueTaskCreateRequestModel } from '../models';

export const mapCreateQueueRequest = (request: CreateQueueModel) =>
  new ProjectQueueTaskCreateRequestModel({
    Name: request.Name,
    GroupId: request.GroupId,
    NamespaceId: request.NamespaceId,
  });
